import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import {router} from './router'
// import LoadScript from 'vue-plugin-load-script';

// Vue.use(LoadScript);
Vue.use(VueRouter);
Vue.config.productionTip = true;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
